import ApartmentAccessGroupsModal from './ApartmentAccessGroupsModal';

export default ApartmentAccessGroupsModal;
